<template>
  <div class="message-list">
    <div
      class="message-item"
      :class="{
        error: isTypeError(message),
        success: isTypeSuccess(message),
        warning: isTypeWarning(message),
        info: isTypeInfo(message),
      }"
      v-for="(message, index) in getMessagesToDisplay()"
      :key="index"
    >
      <a class="close" href="" @click.prevent="hideMessage(message.id)" v-if="message.options.hideButton"></a>
      <span class="text">{{ message.text }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import { MESSAGE_TYPE } from '@/base/const/messages.const'
import { ToolsClass } from '@/base/class/tools.class'

defineOptions({ name: 'Messages' })

const store = useStore()

let cleanupHandler = null
const handlers = []

const messages = computed(() => store.getters.getNotices)

function isTypeError(message) {
  return message.type === MESSAGE_TYPE.error
}

function isTypeSuccess(message) {
  return message.type === MESSAGE_TYPE.success
}

function isTypeWarning(message) {
  return message.type === MESSAGE_TYPE.warning
}

function isTypeInfo(message) {
  return message.type === MESSAGE_TYPE.info
}

function autoHideMessages() {
  const messageList = messages.value.filter((message) => message.options.autoHide && !message.options.displayed)
  messageList.forEach((message) => {
    let handler = handlers.find((item) => item.id === message.id)
    if (handler) {
      return
    }
    handler = {
      id: message.id,
      handler: setTimeout(() => {
        store.dispatch('setMessageAsDisplayed', message.id)
        removeHandler(message.id)
      }, message.options.time),
    }
    handlers.push(handler)
  })
}

function hideMessage(id) {
  const handlerItem = handlers.find((item) => item.id === id)
  if (handlerItem) {
    clearTimeout(handlerItem.handler)
    removeHandler(id)
  }
  store.dispatch('removeMessage', id)
}

function removeHandler(id) {
  const handlerItem = handlers.find((item) => item.id === id)
  if (!handlerItem) {
    return
  }
  const index = handlers.indexOf(handlerItem)
  handlers.splice(index, 1)
}

function getMessagesToDisplay() {
  return messages.value.filter((message) => !message.options.displayed)
}

watch(messages, (val) => {
  if (val.length) {
    ToolsClass.scrollToElementTop(document.querySelector('header'))
    autoHideMessages()
  }
})

onMounted(() => {
  cleanupHandler = setInterval(() => {
    store.dispatch('removeDisplayedMessages')
  }, 10000)
})

onUnmounted(() => {
  clearInterval(cleanupHandler)
})
</script>
